import { Stack, Typography } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import {
  colors,
  spacing,
  typography,
} from "../../../../../../../../../assets/styles/tokens";
import { Box } from "@mui/system";
import FraudPlayersSortBy from "./FraudPlayersSortBy";
import BeAwareBrandSearchDrawer from "../BeAwareBrandSearchDrawer";
import { getFraudPlayersDateRange } from "../../../../../../helpers/bizDevelopmentDashboardHelpers";

interface FraudPlayersFilterProps {
  brandCount?: number;
  onDownload?: () => void;
  downloadDisabled?: boolean;
  sortKey: string;
  sortDir: "asc" | "desc";
  onApplySort: (key: string, dir: "asc" | "desc") => void;

  // Brand name search
  brandList?: string[];
  brandName?: string;
  onBrandNameChange?: (value: string) => void;
}

const FraudPlayersFilter = ({
  brandCount = 0,
  onDownload,
  downloadDisabled = false,
  sortKey,
  sortDir,
  onApplySort,
  brandList = [],
  brandName = "",
  onBrandNameChange,
}: FraudPlayersFilterProps) => {
  // Fixed review window — the current month (MTD).
  const { start, end } = getFraudPlayersDateRange();
  const dateRangeLabel = `MTD, ${start.format("DD/MM/YYYY")} - ${end.format(
    "DD/MM/YYYY",
  )}`;

  return (
    <>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <TextField
          size="small"
          value={dateRangeLabel}
          disabled={true}
          slotProps={{ input: { readOnly: true } }}
          sx={{
            width: "100%",
            padding: "2px !important",
            "& .MuiInputBase-input": {
              fontSize: typography.Size.Text.sm.$value,
              lineHeight: typography.Line_height.text.sm.$value,
              fontWeight: typography.Font_weight.Semibold.$value,
              py: "5px !important",
            },
            "& .MuiOutlinedInput-root": {
              borderRadius: spacing.Radius.md.$value,
              "&.Mui-focused fieldset": {
                borderColor: colors.GrayLightMode[300].$value,
                borderWidth: "1px",
              },
            },
          }}
        />
      </Stack>

      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{
          mt: spacing.Spacing.md.$value,
          color: colors.GrayLightMode[900].$value,
        }}
      >
        <Box>
          <Typography
            display={"flex"}
            alignItems={"center"}
            flexDirection={"row"}
            gap={1}
            sx={{
              fontSize: typography.Size.Text.xs.$value,
              fontWeight: typography.Font_weight.Regular.$value,
            }}
          >
            Sort by:{" "}
            <FraudPlayersSortBy
              sortKey={sortKey}
              sortDir={sortDir}
              onApply={onApplySort}
            />
          </Typography>
          <Typography
            sx={{
              fontSize: typography.Size.Text.xs.$value,
              mt: spacing.Spacing.sm.$value,
            }}
          >
            {brandCount} Brands
          </Typography>
        </Box>

        <Box>
          <BeAwareBrandSearchDrawer
            brandList={brandList}
            brandName={brandName}
            onBrandNameChange={onBrandNameChange}
          />
          <IconButton
            color="secondary"
            size="large"
            onClick={onDownload}
            disabled={downloadDisabled}
            data-tracker="865"
          >
            <FileDownloadIcon
              sx={{ color: colors.GrayLightMode[700].$value }}
            />
          </IconButton>
        </Box>
      </Stack>
    </>
  );
};

export default FraudPlayersFilter;
